"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _formWrapper = require("../../../reducers/formWrapper.js");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefinitions = window.cccisd.appDefs;
var FieldMapper = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldMapper, _React$Component);
  function FieldMapper() {
    var _this;
    _classCallCheck(this, FieldMapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FieldMapper, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      busy: false,
      filteredQueryData: [],
      focusedBefore: false,
      graphqlParams: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
        graphqlSettings = _this$props.graphqlSettings,
        operation = _this$props.operation;
      if ((0, _get2["default"])(graphqlSettings, 'edit.filterQuery') && !_this.state.focusedBefore && operation === 'edit') {
        _this.onFocus();
      }
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_assertThisInitialized(_this), "getFieldBlockSettings", function () {
      var _this$props2 = _this.props,
        displaySettings = _this$props2.displaySettings,
        field = _this$props2.field,
        validationSettings = _this$props2.validationSettings;
      return {
        field: field,
        label: /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: displaySettings.toolTip
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-primary"
        }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
          spaceLeft: true
        })))),
        required: validationSettings && validationSettings.isRequired ? validationSettings.isRequired : false
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onChangeProxy", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var arg;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              arg = event instanceof Event ? event.target.value : event;
              _context.next = 3;
              return _this.props.changeAllFields(arg, _this.props);
            case 3:
              if (_this.props.isUserCheckField && _this.props.shouldCheckUser) {
                _this.props.runCheckUser();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onFocus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props3, graphqlSettings, operation, gqlStgs, reduxForm, gqlParams, shouldRun;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this.setState({
              focusedBefore: true
            });
            _this$props3 = _this.props, graphqlSettings = _this$props3.graphqlSettings, operation = _this$props3.operation;
            if (!(!graphqlSettings || !graphqlSettings[operation])) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", false);
          case 4:
            gqlStgs = graphqlSettings[operation];
            reduxForm = _this.props.reduxForm && _this.props.reduxForm.DynamicForm;
            if (!(gqlStgs.filterQuery && gqlStgs.requiredVariables && reduxForm)) {
              _context2.next = 13;
              break;
            }
            gqlParams = {};
            shouldRun = false;
            gqlStgs.requiredVariables.forEach(function (rq) {
              if (rq.reduxField) {
                var reduxValue = reduxForm[rq.reduxField].value;
                gqlParams[rq.variable] = reduxValue;
                if (reduxValue && !Array.isArray(reduxValue) && rq.reduxValueNotArray && (!_this.state.graphqlParams || _this.state.graphqlParams[rq.variable] !== reduxValue)) {
                  shouldRun = true;
                }
              }
            });
            if (!shouldRun) {
              _context2.next = 13;
              break;
            }
            _context2.next = 13;
            return _this.updateQueryData(gqlStgs.filterQuery, gqlParams);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return _this;
  }
  _createClass(FieldMapper, [{
    key: "updateQueryData",
    value: (
    /**
     * Set the filteredQueryData if we have a new reduxValue.
     * @param {Object} gqlSettings The GraphQL settings for this field
     * @param {mixed} reduxValue The value set by the referenced redux form field
     * @param {Object} gqlParams The parameters to include in the GraphQL query
     */
    function () {
      var _updateQueryData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(query, gqlParams) {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.setState({
                busy: true
              });
              _context3.next = 3;
              return _cccisdApollo.client.query({
                query: (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                ", "\n            "])), query),
                fetchPolicy: 'network-only',
                variables: gqlParams
              });
            case 3:
              response = _context3.sent;
              this.setState({
                busy: false,
                filteredQueryData: response.data,
                graphqlParams: gqlParams
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateQueryData(_x2, _x3) {
        return _updateQueryData.apply(this, arguments);
      }
      return updateQueryData;
    }()
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    )
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        displaySettings = _this$props4.displaySettings,
        emptyValue = _this$props4.emptyValue,
        field = _this$props4.field,
        graphqlSettings = _this$props4.graphqlSettings,
        isDisabled = _this$props4.isDisabled,
        loadedData = _this$props4.loadedData,
        operation = _this$props4.operation,
        requiredByFields = _this$props4.requiredByFields,
        validationSettings = _this$props4.validationSettings;
      var DOMField = '';
      var data = [];
      var isMulti = displaySettings.selectionType === 'multi';
      var _groupBy = 'fieldProps' in displaySettings && displaySettings.fieldProps.groupBy || {};
      var createGroupLabelByValueMap = function createGroupLabelByValueMap(d) {
        var valuePath = _groupBy.valuePath,
          labelPath = _groupBy.labelPath;
        return valuePath ? d.reduce(function (a, c) {
          var value = (0, _get2["default"])(c, valuePath);
          var label = (0, _get2["default"])(c, labelPath);
          a[value] = value ? label : '---';
          return a;
        }, {}) : {};
      };
      switch (displaySettings.renderAs) {
        case 'checkbox':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, Object.assign(this.getFieldBlockSettings(), {
            label: ''
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "checkbox"
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            type: "checkbox"
          })), /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: displaySettings.toolTip
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "text-primary"
          }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
            spaceLeft: true
          })))))));
          break;
        case 'date':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], _extends({
            disabled: isDisabled,
            onChange: this.onChangeProxy,
            placeholderText: displaySettings.placeholder || '',
            selected: field.value,
            useDateFormatAsPlaceholder: displaySettings.useDateFormatAsPlaceholder
          }, displaySettings.fieldProps)));
          break;
        case 'dateTime':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], _extends({
            dateFormat: displaySettings.dateFormat ? displaySettings.dateFormat : 'LLL d, yyyy h:mm a',
            disabled: isDisabled,
            onChange: this.onChangeProxy,
            placeholderText: displaySettings.placeholder || '',
            selected: field.value,
            showTimeSelect: true,
            timeCaption: "time",
            timeFormat: "HH:mm",
            timeIntervals: 30,
            useDateFormatAsPlaceholder: displaySettings.useDateFormatAsPlaceholder
          }, displaySettings.fieldProps)));
          break;
        case 'enum':
          {
            data = !(0, _isEmpty2["default"])((0, _filter2["default"])(AppDefinitions.pawn.fields, function (f) {
              return f.handle === displaySettings.enumFieldHandle;
            })) ? (0, _cloneDeep2["default"])((0, _filter2["default"])(AppDefinitions.pawn.fields, function (f) {
              return f.handle === displaySettings.enumFieldHandle;
            })[0].values) : [];
            if (!isMulti && !(0, _isEmpty2["default"])(data) && 'placeholder' in displaySettings) {
              var object = {
                value: emptyValue || '',
                name: displaySettings.placeholder
              };
              data.unshift(object);
            }
            var groupLabelByValue = createGroupLabelByValueMap(data);
            var GroupLabel = function GroupLabel(_ref3) {
              var item = _ref3.item;
              return /*#__PURE__*/_react["default"].createElement("span", null, groupLabelByValue[item]);
            };
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), isMulti ? /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], _extends({}, displaySettings.fieldProps, {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              filter: "contains",
              onChange: function onChange(value) {
                return _this2.onChangeProxy(value.map(function (d) {
                  return d.value;
                }));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, 'name');
              },
              valueField: "value",
              value: field.value,
              groupBy: function groupBy(item) {
                return (0, _get2["default"])(item, _groupBy.valuePath);
              },
              groupComponent: GroupLabel
            })) : /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], _extends({}, (0, _omit2["default"])(displaySettings.fieldProps, ['initialValue']), {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              onBlur: field.onBlur,
              onChange: function onChange(item) {
                return _this2.onChangeProxy((0, _get2["default"])(item, 'value'));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, 'name');
              },
              value: data.find(function (option) {
                return (0, _get2["default"])(option, 'value') === field.value;
              })
            })));
            break;
          }
        case 'hidden':
          DOMField = /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "hidden"
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            onChange: this.onChangeProxy
          }));
          break;
        case 'input':
          // if requiredByFields is not empty we need custom onChange
          // handler and need to render FieldBlock instead
          // TODO: Is this distinction needed? They both have the same onChange!
          if (!(0, _isEmpty2["default"])(requiredByFields)) {
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement("input", {
              className: "form-control",
              disabled: isDisabled,
              onBlur: field.onBlur,
              onChange: this.onChangeProxy,
              placeholder: displaySettings.placeholder || '',
              value: field.value
            }));
          } else {
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
              disabled: isDisabled,
              field: field,
              label: /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
                title: displaySettings.toolTip
              }, /*#__PURE__*/_react["default"].createElement("span", {
                className: "text-primary"
              }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
                spaceLeft: true
              })))),
              onChange: this.onChangeProxy,
              placeholder: displaySettings.placeholder || '',
              required: validationSettings && validationSettings.isRequired ? validationSettings.isRequired : false
            });
          }
          break;
        case 'instructionalText':
          {
            if (isDisabled) {
              DOMField = null;
              break;
            }
            var text = displaySettings.instructionalText;
            if (displaySettings.requiredVariables) {
              displaySettings.requiredVariables.forEach(function (replaceVariable) {
                var value = (0, _get2["default"])(loadedData, replaceVariable.field);
                if (!(0, _isNil2["default"])(value)) {
                  text = text.replace("%".concat(replaceVariable.variable, "%"), value);
                }
              });
            }
            DOMField = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: text
            }));
            break;
          }
        case 'select':
          {
            var _textField = 'name';
            var valueField = 'value';
            if ('options' in displaySettings) {
              // if the options are enumerated in display settings
              // we should follow the construct 'name' and 'value'

              data = displaySettings.options;
              if ('placeholder' in displaySettings) {
                var hasPlaceholder = data.find(function (e) {
                  return e.name === displaySettings.placeholder;
                });
                if (!hasPlaceholder) {
                  var _object = {
                    value: emptyValue || '',
                    name: displaySettings.placeholder
                  };
                  data.unshift(_object);
                }
              }
            } else {
              // get select options from graphql

              // if no graphqlSettings, this no longer makes sense
              if ((0, _isEmpty2["default"])(graphqlSettings) || !graphqlSettings[operation]) {
                return;
              }
              var gqlStgs = graphqlSettings[operation];

              // Use filteredQueryData if we rely upon a reduxField,
              // loadedData otherwise.
              var dataInextensible = gqlStgs.filterQuery ? (0, _get2["default"])(this.state.filteredQueryData, gqlStgs.optionsPath) : (0, _get2["default"])(loadedData, gqlStgs.optionsPath);

              // if no textFieldPath or valueFieldPath it will
              // assume there is "name" and "value" in the top level
              if (gqlStgs.fieldSettings) {
                _textField = gqlStgs.fieldSettings.textFieldPath;
                valueField = gqlStgs.fieldSettings.valueFieldPath;
              }
              if ('placeholder' in displaySettings && !isMulti) {
                var _object2 = {};
                _object2 = (0, _set2["default"])(_object2, gqlStgs.fieldSettings.textFieldPath, displaySettings.placeholder);

                // let's cheat the redux form value by setting it back to the
                // empty value
                _object2 = (0, _set2["default"])(_object2, gqlStgs.fieldSettings.valueFieldPath, emptyValue);
                data.push(_object2);
              }
              data = data.concat(dataInextensible);
              if (isMulti) {
                data = data.map(function (d) {
                  return _objectSpread(_objectSpread({}, d), {}, {
                    _value: (0, _get2["default"])(d, valueField)
                  });
                });
              }
            }
            var _groupLabelByValue = createGroupLabelByValueMap(data);
            var _GroupLabel = function _GroupLabel(_ref4) {
              var item = _ref4.item;
              return /*#__PURE__*/_react["default"].createElement("span", null, _groupLabelByValue[item]);
            };
            DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), isMulti ? /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], _extends({}, displaySettings.fieldProps, {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              filter: "contains",
              onChange: function onChange(value) {
                return _this2.onChangeProxy(value.map(function (d) {
                  return d._value;
                }));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, _textField);
              },
              valueField: "_value",
              value: field.value,
              groupBy: function groupBy(item) {
                return (0, _get2["default"])(item, _groupBy.valuePath);
              },
              groupComponent: _GroupLabel
            })) : /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], _extends({}, (0, _omit2["default"])(displaySettings.fieldProps, ['initialValue']), {
              busy: this.state.busy,
              data: data,
              disabled: isDisabled,
              onBlur: field.onBlur,
              onChange: function onChange(item) {
                return _this2.onChangeProxy((0, _get2["default"])(item, valueField));
              },
              onFocus: this.onFocus,
              placeholder: displaySettings.placeholder || '',
              textField: function textField(item) {
                return (0, _get2["default"])(item, _textField);
              },
              value: data.find(function (option) {
                return (0, _get2["default"])(option, valueField) === field.value;
              })
            })));
            break;
          }
        case 'toggle':
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, Object.assign(this.getFieldBlockSettings(), {
            label: ''
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            label: /*#__PURE__*/_react["default"].createElement("span", null, displaySettings.label || '', displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: displaySettings.toolTip
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "text-primary"
            }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
              spaceLeft: true
            }))))
          })))));
          break;
        case 'textarea':
        default:
          DOMField = /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, this.getFieldBlockSettings(), /*#__PURE__*/_react["default"].createElement("textarea", _extends({
            className: "form-control",
            rows: 3
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(field), {
            disabled: isDisabled
          })));
          break;
      }
      return DOMField;
    }
  }]);
  return FieldMapper;
}(_react["default"].Component);
_defineProperty(FieldMapper, "propTypes", {
  /**
   * Callback to change the redux value of the field AND all fields that
   * depend on it
   */
  changeAllFields: _propTypes["default"].func,
  displaySettings: _propTypes["default"].object,
  emptyValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object, _propTypes["default"].array, _propTypes["default"].bool]),
  /** The redux form fields object */
  field: _propTypes["default"].object.isRequired,
  /** Each appdef field, keyed by handle (needed for changeAllFields) */
  fieldTypes: _propTypes["default"].object,
  /** GraphQL appdef settings */
  graphqlSettings: _propTypes["default"].object,
  isDisabled: _propTypes["default"].bool,
  /** Is this field a field that needs userCheck? */
  isUserCheckField: _propTypes["default"].bool,
  /** All data loaded from graphql */
  loadedData: _propTypes["default"].object,
  /** 'create' or 'edit' */
  operation: _propTypes["default"].string,
  /** The reduxForm, from mapStateToProps */
  reduxForm: _propTypes["default"].object,
  /**
   * Array of field handles which should be set to the same value as this
   * field, keyed by handles (needed for changeAllFields)
   */
  requiredByFields: _propTypes["default"].object,
  /** Run the checkUser function */
  runCheckUser: _propTypes["default"].func,
  /** Whether we need to run the check or not */
  shouldCheckUser: _propTypes["default"].bool,
  validationSettings: _propTypes["default"].object
});
_defineProperty(FieldMapper, "defaultProps", {
  isDisabled: false
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    reduxForm: state.form
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields
})(FieldMapper);